import axios from './http'
import QS from 'qs'
import base from './base'

const myHttp = {
  // 登录
    /**
     * 获取首页可视化大屏项目  打卡记录
     * /largeScreenInterface/punchingCardRecord
     */
    punchingCardRecord: function (data) {
      return axios({
          url: `${base.url}/largeScreenInterface/punchingCardRecord`,
          method: 'get',
          params: data
      })
  },
  // 大屏能耗监测设备列表
    // projectId：项目id
    waterElectricityListMessage: function (data) {
      return axios({
          url: `${base.url}/largeScreenInterface/waterElectricityListMessage`,
          method: 'get',
          params: data
      })
  },
   /**
 * /largeScreenInterface/equipmentWaterAVG 大屏能耗监测日用水量
 * @param projectId  项目id
 * @param id 设备id
 
 */
   equipmentWaterAVG: function (data) {
    return axios({
        url: `${base.url}/largeScreenInterface/equipmentWaterAVG`,
        method: 'get',
        params: data
    })
},
  /**
  * /largeScreenInterface/equipmentWaterAVG 大屏能耗监测日用电量
  * @param projectId  项目id
  * @param id 设备id
  
  */
  equipmentElectricityAVG: function (data) {
    return axios({
        url: `${base.url}/largeScreenInterface/equipmentElectricityAVG`,
        method: 'get',
        params: data
    })
},
// 水电预警记录列表
    /**
     * 
     * @param  projectId 项目id
         @param id 设备id
         @param imei 设备序列号
         @param type 设备类型
         @param pageSize 
         @param pageNum
     * @returns 
     */
         energyConsumingInfo: function (data) {
          return axios({
              url: `${base.url}/waterElectricity/energyConsumingInfo`,
              method: 'get',
              params: data
          })
      },
        /**
  * /largeScreenInterface/equipmentQuarterWaterElectricity 大屏水电表季度数据
  * @param projectId  项目id
  * @param id 设备id
  * @param type 1水表2电表
  
  */
    equipmentQuarterWaterElectricity: function (data) {
      return axios({
          url: `${base.url}/largeScreenInterface/equipmentQuarterWaterElectricity`,
          method: 'get',
          params: data
      })
  },
      /**
    * 扬尘列表--预警记录
    * /dust/selectYJnewDust
    */

      selectYJnewDust: function (data) {
        return axios({
            url: `${base.url}/dust/selectYJnewDust`,
            method: 'get',
            params: data
        })
    },
     /**
     * 扬尘列表--季度数据
     * /dust/selectYearTj
     */

     selectYearTj: function (data) {
      return axios({
          url: `${base.url}/dust/selectYearTj`,
          method: 'get',
          params: data
      })
  },
      /**
     * 龙门吊列表
     * equipGantry/selectEquipGantryPage
     */
      selectEquipGantryPage: function (data) {
        return axios({
            url: `${base.url}/equipGantry/selectEquipGantryPage`,
            method: 'get',
            params: data
        })
    },
          /**
     * 单位出勤人员统计
     *   /projectEnt/selectDayEntCount
     * projectId：''//项目id
     */
          selectDayEntCount: function (data) {
            return axios({
                url: `${base.url}/projectEnt/selectDayEntCount`,
                method: 'get',
                params: data
            })
        },
        // 大屏劳务管理劳务公司占比
             /**
     * 单位出勤人员统计
     * /projectEnt/selectEntCount
     * projectId：''//项目id
     */
             selectEntCount: function (data) {
              return axios({
                  url: `${base.url}/projectEnt/selectEntCount`,
                  method: 'get',
                  params: data
              })
          },
             /**
     * 获取首页可视化大屏项目  年龄分布
     * /largeScreenInterface/ageDistribution
     */
    ageDistribution: function (data) {
      return axios({
          url: `${base.url}/largeScreenInterface/ageDistribution`,
          method: 'get',
          params: data
      })
  },
//    查询升降机一小时内的预警次数
// /elevator/getCountWarningOneDate
getCountWarningOneDate: function (data) {
  return axios({
      url: `${base.url}/elevator/getCountWarningOneDate`,
      method: 'get',
      params: data
  })
},
  
}

export default myHttp